import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

interface AuthGuardResult {
  isAuthenticated: boolean;
  user: any;
  authValidated: boolean;
}

/**
 * Hook to guard components against unauthenticated API calls
 * Prevents API calls when user is not authenticated
 */
export const useAuthGuard = (): AuthGuardResult => {
  const user = useSelector((state: RootState) => state.auth.user);
  const [authValidated, setAuthValidated] = useState(false);

  useEffect(() => {
    // Validate authentication status
    if (user !== null) {
      // User is authenticated
      setAuthValidated(true);
    } else if (user === null) {
      // User is explicitly not authenticated
      setAuthValidated(true);
    }
    // If user is undefined, we're still loading
  }, [user]);

  return {
    isAuthenticated: !!user,
    user,
    authValidated
  };
};
